<video [attr.width]="width" (play)="playVideo(videoUrl)" controlsList="nodownload" controls [attr.height]="height"
  #videoPlayer>
  <source [attr.src]="videoUrl" type="video/mp4" />
  Browser not supported
</video>